module.exports = __webpack_public_path__ + "img/crop_for_selector.d188704f.svg";